/**
 * Dark tooltip used by the insights chart segments (funnel bars, performance
 * stacked bar). Centred above the trigger with a small rotated arrow.
 *
 * Designed to live inside a `relative` parent so the absolute positioning
 * resolves correctly.
 */
export function ChartTooltip({ children }: { children: React.ReactNode }) {
  return (
    <div className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 z-10 pointer-events-none">
      <div className="bg-[#0a0d12] text-white text-xs font-semibold px-3 py-2 rounded-lg shadow-xl whitespace-nowrap">
        {children}
      </div>
      <div className="w-2 h-2 bg-[#0a0d12] rotate-45 mx-auto -mt-1" />
    </div>
  );
}
